import {
	ACTION,
	ACTION_SUBJECT,
	EVENT_TYPE,
	type AnalyticsEventPayload,
	type EditorAnalyticsAPI,
} from '@atlaskit/editor-common/analytics';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';

/**
 * Attach analytics for manual autocomplete trigger (e.g. Cmd+Shift+Space).
 * Pattern matches editor-plugin-annotation transform analytics (attach on transaction).
 */
export const addAutocompleteInvokedAnalytics =
	(editorAnalyticsAPI: EditorAnalyticsAPI | undefined) =>
	(transaction: Transaction): Transaction => {
		const payload = {
			action: ACTION.INVOKED,
			actionSubject: ACTION_SUBJECT.AI_AUTOCOMPLETE,
			eventType: EVENT_TYPE.TRACK,
		} as AnalyticsEventPayload;
		editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
		return transaction;
	};

/**
 * Attach analytics when a suggestion is shown (API returned).
 */
export const addAutocompleteViewedAnalytics =
	(editorAnalyticsAPI: EditorAnalyticsAPI | undefined) =>
	(transaction: Transaction): Transaction => {
		const payload = {
			action: ACTION.SUGGESTION_VIEWED,
			actionSubject: ACTION_SUBJECT.AI_AUTOCOMPLETE,
			eventType: EVENT_TYPE.TRACK,
		} as AnalyticsEventPayload;
		editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
		return transaction;
	};

/**
 * Attach analytics when the user accepts a suggestion (e.g. Tab).
 */
export const addAutocompleteAcceptedAnalytics =
	(editorAnalyticsAPI: EditorAnalyticsAPI | undefined) =>
	(transaction: Transaction): Transaction => {
		const payload = {
			action: ACTION.SUGGESTION_INSERTED,
			actionSubject: ACTION_SUBJECT.AI_AUTOCOMPLETE,
			eventType: EVENT_TYPE.TRACK,
		} as AnalyticsEventPayload;
		editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
		return transaction;
	};

/**
 * Attach analytics when the user dismisses or rejects a suggestion.
 */
export const addAutocompleteRejectedAnalytics =
	(editorAnalyticsAPI: EditorAnalyticsAPI | undefined) =>
	(transaction: Transaction): Transaction => {
		const payload = {
			action: ACTION.SUGGESTION_DISMISSED,
			actionSubject: ACTION_SUBJECT.AI_AUTOCOMPLETE,
			eventType: EVENT_TYPE.TRACK,
		} as AnalyticsEventPayload;
		editorAnalyticsAPI?.attachAnalyticsEvent(payload)(transaction);
		return transaction;
	};
